import { DOMParser } from 'xmldom';
import { parseSlide } from './CartoonistSlideParser';
import storeManager from '../store/StoreManager';
import createShapes from '../components/utils/CreateShapes';
import uuid from 'uuid';
import appParameters from '../components/utils/AppParameters';
import saveManager from '../components/utils/SaveManager';
import configuration from '../constants/Configuration';
import { initTimelines } from '../actions/AudioEditorActions';
import slideUtils from '../components/utils/SlidesUtils';
import playController from '../components/utils/PlayController';
import masterUniverseUtils from '../components/utils/MasterUniverseUtils';
import textEditorUtils from '../components/menus/textEditorTool/utils/TextEditorUtils';
import platformDetection from '../components/utils/PlatformDetection';

function setAudioEditorState(data) {
    const dispatch = storeManager.getStore().dispatch;

    var newData = {};

    newData.timelines = data.timelines;
    newData.zoomValue = data.zoomValue;

    dispatch(initTimelines(newData));
}

export function createSlideModel() {
    var slide = {};
    const backgroundModel = createShapes.createBackground();

    slide.content = [backgroundModel];
    slide.initialized = true;
    slide.time = configuration.SLIDE_DURATION;
    slide.uuid = uuid.v4();
    slide.contentItemId = -1; // contentItemId for sound
    slide.sound = ''
    slide.soundEffect = '';
    slide.soundVolume = 0.5;
    slide.soundEffectVolume = 0.5;

    return slide;
}

function checkNodeStyle(shapeModel, parentNode) {
    if (parentNode.childNodes && parentNode.childNodes.length > 0) {
        let firstElement = parentNode.childNodes[0];

        if (firstElement.style && firstElement.style['font-family'])
            shapeModel.fontFamily = firstElement.style['font-family'];

        if (firstElement.style && firstElement.style['font-size'])
            shapeModel.fontSize = parseInt(firstElement.style['font-size']);

        if (firstElement.style && firstElement.style['color'])
            shapeModel.fontColor = firstElement.style['color'];

        if (firstElement.style && firstElement.style['font-weight'])
            shapeModel.fontBold = firstElement.style['font-weight'];

        if (firstElement.style && firstElement.style['font-style'])
            shapeModel.fontItalic = firstElement.style['font-style'];

        if (firstElement.style && firstElement.style['text-decoration-line'])
            shapeModel.fontUnderline = firstElement.style['text-decoration-line'];

        if (firstElement.style && firstElement.style['text-align'])
            shapeModel.fontAlign = firstElement.style['text-align'];

        checkNodeStyle(shapeModel, firstElement);
    }
}

function convertNewTextShapeToOld(shapeModel) {
    shapeModel.isRichText = undefined;

    if (shapeModel.imageNode) {
        shapeModel.imageNode = '';
        shapeModel.aspectRatio = 1;
    }

    let divElement = document.createElement('div');

    document.body.appendChild(divElement);

    divElement.innerHTML = shapeModel.htmlText;

    shapeModel.fontFamily = textEditorUtils.currentFont;
    shapeModel.fontSize = textEditorUtils.currentFontSize;
    shapeModel.fontAlign = 'left';
    shapeModel.fontBold = false;
    shapeModel.fontItalic = false;
    shapeModel.fontUnderline = false;
    shapeModel.fontColor = '#000000';

    shapeModel.htmlText = divElement.innerText;

    checkNodeStyle(shapeModel, divElement);

    document.body.removeChild(divElement);

    return shapeModel;
}

function checkForOldTextShapes(slides) {
    if (platformDetection.isIOS()) {
        let newSlides = [];

        for (let i=0; i<slides.length; i++) {
            let currentSlide = slides[i];
            let shapes = currentSlide.content;
            let newShapes = [];

            for (let j=0; j<shapes.length; j++) {
                let currentShape = shapes[j];

                if (currentShape.isRichText)
                    currentShape = convertNewTextShapeToOld(currentShape);

                newShapes.push(currentShape);
            }

            currentSlide.content = newShapes;
            newSlides.push(currentSlide);
        }

        return newSlides;
    } else
        return slides;
}

export function loadNewContent(data) {
    var production = {};

    if (data == undefined) {
        const slide = createSlideModel();
        production.title = appParameters.title;
        production.slides = [slide];
    } else {
        // added this one to fix a production
        data = data.replace(/\n/g, "");
        data = data.replace('"Triton"', "'Triton'");
        data = data.replace('Kreuzer_"Bl', 'Kreuzer_Bl');
        data = data.replace('cher".jpg', 'cher.jpg');

        var wrongIndex = data.indexOf('#');

        if (wrongIndex > 0 && wrongIndex < 40)
            data = data.replace('#', '');

        data = JSON.parse(data);

        var slides = data.slides;
        slideUtils.updateFreehandData(slides);

        if (!appParameters.isMaster) {
            if (data.theme)
                appParameters.currentTheme = data.theme;

            if (appParameters.currentTheme != '') {
                masterUniverseUtils.checkCurrentUniverse();
            }
        }

        production.slides = checkForOldTextShapes(slides);
        production.storySoundVolume = data.storySoundVolume;
        production.storySound = data.storySound;
        production.hiddenAlerts = data.hiddenAlerts;
        production.title = appParameters.title;

        if (data.currentFont && data.currentFont.length > 0)
            textEditorUtils.currentFont = data.currentFont;

        if (data.currentFontSize && data.currentFontSize.length > 0)
            textEditorUtils.currentFontSize = parseInt(data.currentFontSize);

        if (data.exportProperties)
            production.exportProperties = data.exportProperties;

        if (data.audioEditor)
            setAudioEditorState(data.audioEditor);
    }

    return production;
}

export function loadAudioContent(data) {
    var production = {};

    if (data == undefined) {
        const slide = createSlideModel();
        production.title = appParameters.title;
        production.slides = [slide];

        setAudioEditorState(playController.getEmptyTimelines());
    } else {
        data = JSON.parse(data);

        production.title = appParameters.title;
        production.slides = data.slides;

        if (data.audioEditor)
            setAudioEditorState(data.audioEditor);
    }

    return production;
}

export function loadOldContent() {
    const state = storeManager.getState();
    var data;

    if (state.production.data != undefined)
        data = unescape(state.production.data);

    return parseCartoonistXML(data);
}

export function parseCartoonistXML (xmlAsString) {
    var slides;
    var metadata;
    var slide;

    if (xmlAsString == undefined) {
        metadata = {title: appParameters.title};

        slide = createSlideModel();
        slides = {slides: [slide]};
    } else {
        const rootDocument = new DOMParser().parseFromString(xmlAsString, 'text/xml');
        const cartoonistRootElement = rootDocument.getElementsByTagName('structureElement')[0];

        if (cartoonistRootElement == undefined) {
            metadata = {title: appParameters.title};

            slide = createSlideModel();
            slides = {slides: [slide]};
        } else {
            metadata = parseStructureMetadata(cartoonistRootElement);
            slides = parseSlides(cartoonistRootElement);
        }
    }

    return Object.assign({}, metadata, slides);
}

export function parseStructureMetadata(cartoonistRootElement) {
    const title = cartoonistRootElement.getElementsByTagName('title')[0].textContent;

    if (saveManager.getContentItemId() < 0  && appParameters.contentRevisionId < 0 && appParameters.isIcsx == false) { // it's an exercise
    } else {
        appParameters.title = title;
    }

    return {
        title
    };
}

function parseSlides (cartoonistRootElement) {
    var slides = [];
    const elements = cartoonistRootElement.getElementsByTagName('structureElement');
    for (let element of Array.from(elements)) {
        var slideObject = parseSlide(element);

        slideObject.uuid = uuid.v4();

        slides.push(slideObject);
    }

    if (slides.length < 1)
        slides.push(createSlideModel());

    return {
        slides
    };
}



/** WEBPACK FOOTER **
 ** ./src/parser/CartoonistXMLParser.js
 **/